import Vuex from 'vuex'

let Vue = require('vue').default;

Vue.use(Vuex)

import { i18n } from './vue2/langs';

Vue.component('applicant-register', require('./vue2/components/auth/ApplicantRegister.vue').default);

class ApplicantRegister {
    constructor () {
        this.instances = [];
    }
    initInstance(instanceId) {
        let config = {
            el: instanceId,
            i18n
        };
        this.instances[instanceId] = (new Vue(config)).$children[0];
    }
    getInstance(instanceId) {
        return this.instances[instanceId];
    }
}
window.ApplicantRegister = new ApplicantRegister();